import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import Spinner from 'react-bootstrap/Spinner';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faCheck } from '@fortawesome/free-solid-svg-icons';


import 'react-datepicker/dist/react-datepicker.css';
import { useForm, Controller, Feedback } from 'react-hook-form';
import axios from 'axios';
import { URL_EMPLOYEE } from '../../constans/servidor';


import { NavLink, useLocation } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import TableComponent from '../../components/Desenganche/Filtrado';
import { set } from 'immutable';
let dato = []
let cambiar = false

function Formulario(props) {
	// const { modal } = props;
	const { Terminales } = props
	const [myVariable, setMyVariable] = useState('Valor inicial');

	const [errorMessageA, setErrorMessageA] = useState('');
	const [errorMessageB, setErrorMessageB] = useState('');
	const [placa, setPlaca] = useState();
	const [objeto, setObjeto] = useState()
	const [loading, setLoading] = useState(true);
	const [estado, setEstado] = useState(false)
	// const [TerminalesB, setTerminalesB] = useState();

	const [datosCorrectosA, setdatosCorrectosA] = useState(false);
	const [datosCorrectosB, setdatosCorrectosB] = useState(false);
	const {
		control,
		watch,
		handleSubmit,
		reset,
		formState: { errors },
	} = useForm();
	useEffect(() => {
		setTimeout(() => {
			setLoading(false)
		}, 1000);

	}, [Terminales]);
	const regExpCarro = /^[a-z A-Z]{3}[0-9]{3}$/;
	const regExpCarroR = /^[a-z A-Z]{1}[0-9]{4}$/;
	const regExpCarroA = /^[a-z A-Z]{2}[0-9]{4}$/;
	const regExpCarroV = /^[a-z A-Z]{1}[0-9]{5}$/;
	const regExpMoto = /^[a-z A-Z]{3}[0-9]{2}[a-z A-Z]{1}$/;
	const regExpMotoAntigua = /^[a-z A-Z]{3}[0-9]{2}$/;
	const regExpBicis = /^[Bb]ici[0-9]{3}$/;
	const regExpBici = /^[Bb]ici[0-9]{2}$/;

	const verificarPlaca = (placa) => {
		console.log(placa);
		if (
			regExpCarro.test(placa) ||
			regExpCarroR.test(placa) ||
			regExpCarroA.test(placa) ||
			regExpCarroV.test(placa) ||
			regExpMoto.test(placa) ||
			regExpMotoAntigua.test(placa) ||
			regExpBicis.test(placa) ||
			regExpBici.test(placa)
		) {
			console.log('entre');
			setPlaca(true);
		} else {
			setPlaca(false);
		}
	};
	useEffect(() => {

		console.log('terminales 2');
		console.log(Terminales);

	}, []);
	const onSubmit = async (data) => {
		console.log('AQUI');
		var fechaE = new Date(data.fechaExpiracion);
		var anioE = fechaE.getFullYear();
		var mesE = fechaE.getMonth() + 1;
		var diaE = fechaE.getDate();
		var fechaFormateadaE = anioE + "-" + (mesE < 10 ? "0" + mesE : mesE) + "-" + (diaE < 10 ? "0" + diaE : diaE);
		var fechaA = new Date(data.fechaActivacion);
		var anioA = fechaA.getFullYear();
		var mesA = fechaA.getMonth() + 1;
		var diaA = fechaA.getDate();
		var fechaFormateadaA = anioA + "-" + (mesA < 10 ? "0" + mesA : mesA) + "-" + (diaA < 10 ? "0" + diaA : diaA);
		let body = { // creas un objeto
			nombre_convenio: data.convenio.toUpperCase(),
			cod_park: data.terminales.value,
			tiempo_sin_cobro: data.cuartos,
			fecha_inicial: fechaFormateadaA,
			fecha_final: fechaFormateadaE,
		};
		console.log(body);
		try {
			function reloadPage() {
				window.location.reload();
			}
			const resultado = await axios.post(`${URL_EMPLOYEE}/conveniosVirtuales/InsertNewConvenioV`, body)
			if (resultado.data.status) {
				toast.success(resultado.data.message)
				setInterval(reloadPage, 2000);
			} else {
				toast.error(resultado.data.message)

			}

		} catch (error) {
			toast.error('Algo salio mal..');
			setLoading(false);
		}

	}

	return (

		loading ? (
			<div className="cargando">
				<div className="loader" id="loader">
					Loading...
				</div>
			</div>
		) : (
			<>

				<form onSubmit={handleSubmit(onSubmit)}>
					<h1 className='formulario'>Formulario de Convenios</h1>
					<Row className={estado ? "azul mbottom-20" : "contenedorF-Filtrado mbottom-20"} >
						<Col xs={12} sm={6} md={4} lg={4} xl={4}>
							<Form.Group className="inputmayuscula">
								<Form.Label className='texto-label'>Nombre Convenio</Form.Label>
								<Controller
									name="convenio"
									control={control}
									rules={{
										required:'El campo es obligatorio',
										validate: value => value.toLowerCase().includes('virtual') || 'El nombre debe incluir la palabra VIRTUAL',
									}}
									render={({ field: { onChange, onBlur, value } }) => (
										<Form.Control
											type="text"
											onBlur={onBlur}
											onChange={(value) => onChange(value)}
											value={value}
										/>
									)}
								/>
								{errors.convenio && (
									<Form.Text id="passwordHelpBlock" className="error">
										{errors.convenio.message}
									</Form.Text>
								)}
							</Form.Group>
						</Col>
						<Col xs={12} sm={6} md={4} lg={4} xl={4}>
							<Form.Group className="inputmayuscula">
								<Form.Label className='texto-label'>Cuartos de Hora</Form.Label>
								<Controller
									name="cuartos"
									control={control}
									rules={{
										required: {
											value: true,
											message: 'El campo es obligatorio',
										}
									}}
									render={({ field: { onChange, onBlur, value } }) => (
										<Form.Control
											type="number"
											onBlur={onBlur}
											onChange={(value) => onChange(value)}
											value={value}
										/>
									)}
								/>
								{errors.cuartos && (
									<Form.Text id="passwordHelpBlock" className="error">
										El campo es obligatorio
									</Form.Text>
								)}
							</Form.Group>
						</Col>

						{Terminales ? (
							<Col xs={12} sm={4} md={4} lg={4} xl={4}>
								<Form.Group controlId="formBasicEmail">
									<Form.Label className='texto-label'>Parqueadero</Form.Label>
									<Controller
										name="terminales"
										control={control}
										rules={{
											required: {
												value: true,
												message: 'El campo es obligatorio',
											}
										}}
										// rules={{ required: true }}
										render={({ field: { onChange, onBlur, value } }) => (
											<Select
												onChange={(data) => {
													onChange(data);
												}}
												value={value}
												// placeholder="Elige una opción"
												options={Terminales}
											/>

										)}
									/>
									{errors.terminales && (
										<Form.Text id="passwordHelpBlock" className="error">
											El campo es obligatorio
										</Form.Text>
									)}
								</Form.Group>
							</Col>
						) : null}
						<Col xs={12} sm={4} md={4} lg={4} xl={4}>
							<Form.Group controlId="formBasicEmail">
								<Form.Label className='texto-label'>Fecha de Activación</Form.Label>
								<Controller
									name="fechaActivacion"
									control={control}
									rules={{
										required: {
											value: true,
											message: 'El campo es obligatorio',
										}
									}}
									defaultValue={new Date()}
									render={({ field: { onChange, onBlur, value } }) => (
										<DatePicker
											className="form-control"
											selected={value}
											dateFormat="yyyy-MM-dd"
											onChange={(date) => onChange(date)}
										/>
									)}
								/>
								{errors.fechaActivacion && (
									<Form.Text id="passwordHelpBlock" className="error">
										El campo es obligatorio
									</Form.Text>
								)}
							</Form.Group>
						</Col>
						<Col xs={12} sm={4} md={4} lg={4} xl={4}>
							<Form.Group controlId="formBasicEmail">
								<Form.Label className='texto-label'>Fecha de Expiración </Form.Label>
								<Controller
									name="fechaExpiracion"
									control={control}
									rules={{
										required: {
											value: true,
											message: 'El campo es obligatorio',
										}
									}}
									defaultValue={new Date()}
									render={({ field: { onChange, onBlur, value } }) => (
										<DatePicker
											className="form-control"
											selected={value}
											dateFormat="yyyy-MM-dd"
											onChange={(date) => onChange(date)}
										/>
									)}
								/>
								{errors.fechaExpiracion && (
									<Form.Text id="passwordHelpBlock" className="error">
										El campo es obligatorio
									</Form.Text>
								)}
							</Form.Group>
						</Col>

						<Col style={{ marginRight: '20px' }} className="  mbottom-20" xs={12} sm={4} md={4} lg={4} xl={4}>

							<Button style={{ marginRight: '20px' }} type="submit" variant="primary" className=" btn btn-primary mtop-20 boton"
							>
								Crear
							</Button>
						</Col>
					</Row>
				</form>
			</>
		)
	)
};

export default Formulario;
